import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {SemanticSearchFiltersDto} from "../types/SemanticSearchFiltersDto";

/**
 * Builds an offer list URL ("Zobacz wszystkie oferty") from semantic search filters.
 *
 * The API returns an arbitrary set of region IDs (often the whole city decomposed into districts/estates),
 * so we reuse the multi-region offer list (`/ws/`) with region IDs and filters passed as query params -
 * the same pattern the search form uses for multi-region results.
 *
 * Returns `null` when there are no regions to filter by (nothing meaningful to link to).
 */
export function buildSemanticSearchOfferListUrl(filters: SemanticSearchFiltersDto | undefined): string | null {
    if (!filters || !filters.regions || filters.regions.length === 0) {
        return null;
    }

    return appendQueryString(rpAppLink.offer.multiList(), {
        region: filters.regions,
        price_0: filters.min_price_pln ?? undefined,
        price_1: filters.max_price_pln ?? undefined,
        area_0: filters.min_area_m2 ?? undefined,
        area_1: filters.max_area_m2 ?? undefined,
        rooms_0: filters.min_rooms ?? undefined,
        rooms_1: filters.max_rooms ?? undefined
    });
}
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {SemanticSearchFiltersDto} from "../types/SemanticSearchFiltersDto";

/**
 * Builds an offer list URL ("Zobacz wszystkie oferty") from semantic search filters.
 *
 * The API returns an arbitrary set of region IDs (often the whole city decomposed into districts/estates),
 * so we reuse the multi-region offer list (`/ws/`) with region IDs and filters passed as query params -
 * the same pattern the search form uses for multi-region results.
 *
 * Returns `null` when there are no regions to filter by (nothing meaningful to link to).
 */
export function buildSemanticSearchOfferListUrl(filters: SemanticSearchFiltersDto | undefined): string | null {
    if (!filters || !filters.regions || filters.regions.length === 0) {
        return null;
    }

    return appendQueryString(rpAppLink.offer.multiList(), {
        region: filters.regions,
        price_0: filters.min_price_pln ?? undefined,
        price_1: filters.max_price_pln ?? undefined,
        area_0: filters.min_area_m2 ?? undefined,
        area_1: filters.max_area_m2 ?? undefined,
        rooms_0: filters.min_rooms ?? undefined,
        rooms_1: filters.max_rooms ?? undefined
    });
}
